import { services, serviceHeroSlides } from '../components/services/serviceData';
import { DEFAULT_PAGE_CONTENT } from './servicePageTemplate';
import { LEGACY_SERVICE_PAGES } from './legacyServicePagesSeed';
import { DEFAULT_PAGE_CONTENT as ABOUT_DEFAULT_PAGE_CONTENT } from './aboutPageTemplate';
import { DEFAULT_PAGE_CONTENT as HOME_DEFAULT_PAGE_CONTENT } from './homePageTemplate';
import { DEFAULT_PAGE_CONTENT as SERVICES_DEFAULT_PAGE_CONTENT } from './servicesPageTemplate';
import { DEFAULT_PAGE_CONTENT as CASE_STUDIES_DEFAULT_PAGE_CONTENT } from './caseStudiesPageTemplate';
import { DEFAULT_PAGE_CONTENT as CONTACT_DEFAULT_PAGE_CONTENT } from './contactPageTemplate';
import { serviceDetailBySlug } from '../components/services/serviceDetailContent';
import { CS_LIST_STATS, CS_LIST_CARDS } from '../components/case-studies/caseStudiesListingData';
import { CASE_STUDY_DETAILS } from '../components/case-studies/caseStudyDetailContent';
import {
  DEFAULT_CASE_STUDY_CATEGORIES,
  ensureCardsHaveCategoryKeys,
} from './caseStudyCategories';
import {
  BLOG_POSTS,
  BLOG_FEATURED_IDS_BY_TOPIC,
  BLOG_BROWSE_TOPIC_KEYS,
} from '../components/blog/blogPostsData';
import {
  DEFAULT_BLOG_CATEGORIES,
  ensurePostsHaveTopicKeys,
  syncBrowseTopicKeys,
} from './blogCategories';
import { BLOG_VIDEO_POOL } from '../blog/blogVideos';
import { BLOG_HERO_VIDEO } from '../media/blogHeroMedia';
import { TEAM_MEMBERS } from '../components/about/teamMembersData';
import { SOLUTION_VIDEO_SOURCES } from '../components/home/solutionVideosData';
import { HOME_TESTIMONIALS } from '../components/home/testimonialsHomeData';

/** Snapshot of bundled site content for admin editing / API seeding. */
export function getSiteDefaults() {
  return {
    services: {
      list: JSON.parse(JSON.stringify(services)),
      heroSlides: JSON.parse(JSON.stringify(serviceHeroSlides)),
      details: JSON.parse(JSON.stringify(serviceDetailBySlug)),
    },
    caseStudies: {
      stats: JSON.parse(JSON.stringify(CS_LIST_STATS)),
      categories: JSON.parse(JSON.stringify(DEFAULT_CASE_STUDY_CATEGORIES)),
      cards: ensureCardsHaveCategoryKeys(
        JSON.parse(JSON.stringify(CS_LIST_CARDS)),
        DEFAULT_CASE_STUDY_CATEGORIES
      ),
      details: JSON.parse(JSON.stringify(CASE_STUDY_DETAILS)),
    },
    blogs: {
      posts: ensurePostsHaveTopicKeys(
        JSON.parse(JSON.stringify(BLOG_POSTS)),
        DEFAULT_BLOG_CATEGORIES,
        BLOG_FEATURED_IDS_BY_TOPIC
      ),
      categories: JSON.parse(JSON.stringify(DEFAULT_BLOG_CATEGORIES)),
      videoPool: [...BLOG_VIDEO_POOL],
      heroVideo: BLOG_HERO_VIDEO,
      featuredIdsByTopic: JSON.parse(JSON.stringify(BLOG_FEATURED_IDS_BY_TOPIC)),
      browseTopicKeys: syncBrowseTopicKeys(DEFAULT_BLOG_CATEGORIES),
    },
    team: JSON.parse(JSON.stringify(TEAM_MEMBERS)),
    testimonials: {
      items: JSON.parse(JSON.stringify(HOME_TESTIMONIALS)),
    },
    media: {
      blogHeroVideo: BLOG_HERO_VIDEO,
      blogVideoPool: [...BLOG_VIDEO_POOL],
      solutionVideos: { ...SOLUTION_VIDEO_SOURCES },
    },
    servicePages: (() => {
      const now = new Date().toISOString();
      const entries = [
        { slug: 'full-stack-development', title: 'Full-Stack & SaaS Development Services', data: DEFAULT_PAGE_CONTENT },
        ...LEGACY_SERVICE_PAGES.map((s) => ({ slug: s.slug, title: s.title, data: s.data })),
      ];
      const list = entries.map((e) => ({ slug: e.slug, title: e.title, createdAt: now, updatedAt: now }));
      const pages = Object.fromEntries(
        entries.map((e) => [
          e.slug,
          { slug: e.slug, title: e.title, data: JSON.parse(JSON.stringify(e.data)), styles: {}, createdAt: now, updatedAt: now },
        ])
      );
      return { list, pages };
    })(),
    aboutPage: {
      data: JSON.parse(JSON.stringify(ABOUT_DEFAULT_PAGE_CONTENT)),
      styles: {},
      updatedAt: new Date().toISOString(),
    },
    homePage: {
      data: JSON.parse(JSON.stringify(HOME_DEFAULT_PAGE_CONTENT)),
      styles: {},
      updatedAt: new Date().toISOString(),
    },
    servicesPage: {
      data: JSON.parse(JSON.stringify(SERVICES_DEFAULT_PAGE_CONTENT)),
      styles: {},
      updatedAt: new Date().toISOString(),
    },
    caseStudiesPage: {
      data: JSON.parse(JSON.stringify(CASE_STUDIES_DEFAULT_PAGE_CONTENT)),
      styles: {},
      updatedAt: new Date().toISOString(),
    },
    contactPage: {
      data: JSON.parse(JSON.stringify(CONTACT_DEFAULT_PAGE_CONTENT)),
      styles: {},
      updatedAt: new Date().toISOString(),
    },
    updatedAt: null,
  };
}
